import { api } from "@/utils/api";
import { sanitizePathParam } from "@/utils/sanitize";

export default class PluviometerRepository {
  async getPluviometersByLocation(locationId: number): Promise<Location[]> {
    const lid = sanitizePathParam(locationId);
    const locations = await api.get(
      `/measurements/infrastructures/pluviometers/locations/${lid}`
    );
    return locations.data;
  }
}
